import { getGlobalVariables } from '../../api/globalVariables';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getFirestoreGlobalVariablesThunk = createAsyncThunk(
  'firestoreGlobalVariables/getFirestoreGlobalVariables',
  async () => {
    const data = await getGlobalVariables();
    return data;
  }
);
